<div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden;">

  <!-- Saldo header -->
  <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 14px 20px; border-bottom: 2px solid #bbf7d0;">
    <app-withdraw-balance-view [actualBalance]="saldoActual"></app-withdraw-balance-view>
  </div>

  <!-- Horario de operacion -->
  <div style="display: flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 14px; background: #f0fdf4; border-bottom: 1px solid #bbf7d0;">
    <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #16a34a;">schedule</mat-icon>
    <span style="font-size: 0.78rem; font-weight: 600; color: #1e5a3f;">Horario de operacion: 4:00 - 23:00</span>
  </div>

  <div style="padding: 20px;">
    <!-- Monto de retiro input -->
    <div style="margin-bottom: 16px;">
      <label style="display: block; font-size: 0.8rem; font-weight: 600; color: #1e5a3f; margin-bottom: 6px;">Monto de retiro</label>
      <div style="position: relative;">
        <input
          #montoInput
          type="text"
          [(ngModel)]="valorARetiro"
          (keyup)="balanceLeft()"
          placeholder="$ 0"
          pattern="[0-9]*"
          (keypress)="soloNumeros($event)"
          maxlength="8"
          class="no-spinner"
          style="width: 100%; padding: 14px 120px 14px 16px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 1.1rem; font-weight: 700; color: #1f2937; background: white; outline: none; transition: border-color 0.2s ease; box-sizing: border-box;"
          (focus)="montoInput.style.borderColor='#34d399'"
          (blur)="montoInput.style.borderColor='#e5e7eb'"
        >
        <span style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); display: flex; align-items: center; gap: 4px;">
          <button *ngIf="valorARetiro!=''" type="button" (click)="clearValAvailableCLP()"
            style="width: 30px; height: 30px; border-radius: 6px; border: 1px solid #e5e7eb; background: white; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 14px; color: #6b7280; transition: background 0.2s ease;"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            ✕
          </button>
          <button type="button" (click)="maxValAvailableCLP()"
            style="background: #1C593D; color: white; border: none; border-radius: 8px; padding: 4px 12px; font-size: 0.75rem; font-weight: 700; cursor: pointer; transition: background 0.2s;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            MÁX
          </button>
        </span>
      </div>

      <!-- Minimum info -->
      <div *ngIf="!isBelowMinimum && valorRetiro === 0"
        style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; margin-top: 10px;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #16a34a;">info</mat-icon>
        <span style="font-size: 0.78rem; font-weight: 500; color: #1e5a3f;">Monto m&iacute;nimo de retiro <strong>${{ MIN_CLP_WITHDRAW | number:'1.0-0' }} CLP</strong></span>
      </div>

      <!-- Error: below minimum -->
      <div *ngIf="isBelowMinimum"
        style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #fef2f2; border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 10px; margin-top: 10px;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #dc2626;">error</mat-icon>
        <span style="font-size: 0.78rem; font-weight: 600; color: #991b1b;">El monto m&iacute;nimo de retiro es ${{ MIN_CLP_WITHDRAW | number:'1.0-0' }} CLP</span>
      </div>

      <!-- Error: exceeds balance -->
      <div *ngIf="valorRetiro>saldoActual"
        style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #fef2f2; border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 10px; margin-top: 10px;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #dc2626;">error</mat-icon>
        <span style="font-size: 0.78rem; font-weight: 600; color: #991b1b;">El monto de retiro excede el balance actual</span>
      </div>
    </div>

    <!-- Balance restante -->
    <div style="margin-bottom: 16px;">
      <label style="display: block; font-size: 0.8rem; font-weight: 600; color: #1e5a3f; margin-bottom: 6px;">Balance restante</label>
      <input
        type="text"
        [(ngModel)]="valorRestante"
        placeholder="$ 0"
        pattern="[0-9]*"
        (keypress)="soloNumeros($event)"
        maxlength="8"
        readonly
        style="width: 100%; padding: 14px 16px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 1.1rem; font-weight: 700; color: #1e5a3f; background: #f9fafb; outline: none; box-sizing: border-box;"
      >
    </div>

    <!-- Botón Retirar -->
    <button type="button" [disabled]="!isValidWithdrawAmount" (click)="emitChangeStep()"
      [style.opacity]="!isValidWithdrawAmount ? '0.5' : '1'"
      [style.cursor]="!isValidWithdrawAmount ? 'not-allowed' : 'pointer'"
      style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s ease;"
      onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">arrow_forward</mat-icon>
      Continuar
    </button>
  </div>
</div>
